import { Params } from 'react-router';
import Toast from '../Toast';
import { ApiResponse, PaginatedApiResponse, axios } from '../config/axios';
import config from '../config/config';
// const BooksService = ApiFactory({ endpoint: 'tags' });

export const AuthorsService = {
  async all({ per_page, page, search }: any): Promise<PaginatedApiResponse<any>> {
    return await axios.get('/authors', {
      params: {
        per_page,
        page,
        search,
      },
    });
  },
  async allNoPagination(): Promise<ApiResponse<any>> {
    return await axios.get('/authors/all');
  },
  async one(id: Readonly<Params<string>> | undefined): Promise<ApiResponse<any>> {
    return await axios.get(`/authors/${id}`);
  },
  async create(data: { name: string }) {
    try {
      const response = await axios.post(`${config.baseUrl}/authors`, data);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
  async update(id: Readonly<Params<string>> | undefined, data: { name: string }) {
    try {
      const response = await axios.patch(`${config.baseUrl}/authors/${id}`, data);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
  async delete(id: number) {
    try {
      const response = await axios.delete(`${config.baseUrl}/authors/${id}`);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
};

export default AuthorsService;
